// extracted by mini-css-extract-plugin
export default {"inner":"StoreProductsPage_inner__mXwMs","list":"StoreProductsPage_list__MyATs"};